var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "20px", background: "#fff" } },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "shearch-lab" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", plain: "" },
              on: { click: _vm.addFlow }
            },
            [
              _vm._v(
                _vm._s(!_vm.isInDingTalk ? "新增用印审批" : "新增钉钉用印审批")
              )
            ]
          ),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  attrs: { inline: true, model: _vm.signFilter, size: "small" }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: { placeholder: "流程名称" },
                        model: {
                          value: _vm.signFilter.flowName,
                          callback: function($$v) {
                            _vm.$set(_vm.signFilter, "flowName", $$v)
                          },
                          expression: "signFilter.flowName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "120px" },
                          attrs: { placeholder: "请选择流程" },
                          model: {
                            value: _vm.signFilter.orderFlag,
                            callback: function($$v) {
                              _vm.$set(_vm.signFilter, "orderFlag", $$v)
                            },
                            expression: "signFilter.orderFlag"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部类型", value: "" }
                          }),
                          _c("el-option", {
                            attrs: { label: "顺序审批", value: 1 }
                          }),
                          _c("el-option", {
                            attrs: { label: "会审", value: 0 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "120px" },
                          attrs: { placeholder: "请选择状态" },
                          model: {
                            value: _vm.signFilter.useStatus,
                            callback: function($$v) {
                              _vm.$set(_vm.signFilter, "useStatus", $$v)
                            },
                            expression: "signFilter.useStatus"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部状态", value: "" }
                          }),
                          _c("el-option", {
                            attrs: { label: "启用中", value: 0 }
                          }),
                          _c("el-option", {
                            attrs: { label: "已停用", value: 1 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticStyle: { "margin-right": "0px" } },
                    [
                      _c("el-button", { on: { click: _vm.filterSearch } }, [
                        _vm._v("查询")
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.resetFilter }
                        },
                        [_vm._v("重置")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.signTableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "flowName", label: "流程名称", "min-width": "200" }
          }),
          _c("el-table-column", {
            attrs: { prop: "orderFlag", label: "审批流程", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.isInDingTalk
                      ? _c(
                          "span",
                          [
                            _vm._v(
                              _vm._s(
                                (scope.row.flowType === 1
                                  ? "顺序审批："
                                  : "会审：") + " "
                              ) + "\n          "
                            ),
                            scope.row.flowType === 1
                              ? _vm._l(scope.row.nodes, function(node, i) {
                                  return _c("span", { key: i }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(node.userApproveUsers[0].name) +
                                        "\n              "
                                    ),
                                    i < scope.row.nodes.length - 1
                                      ? _c("span", [_vm._v(_vm._s("->"))])
                                      : _vm._e()
                                  ])
                                })
                              : _vm._l(
                                  scope.row.nodes[0].userApproveUsers,
                                  function(node, i) {
                                    return _c("span", { key: i }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(node.name) +
                                          "\n              "
                                      ),
                                      i <
                                      scope.row.nodes[0].userApproveUsers
                                        .length -
                                        1
                                        ? _c("span", [_vm._v("、")])
                                        : _vm._e()
                                    ])
                                  }
                                )
                          ],
                          2
                        )
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              "" +
                                (scope.row.orderFlag === 1
                                  ? "顺序审批："
                                  : "会审：") +
                                scope.row.allPartName +
                                "\n          "
                            )
                          )
                        ])
                  ]
                }
              }
            ])
          }),
          !_vm.isInDingTalk
            ? _c("el-table-column", {
                attrs: { prop: "createTime", label: "创建时间", width: "200" }
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { prop: "useStatus", label: "启用状态", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "span",
                      {
                        style: {
                          color:
                            scope.row.useStatus === 1
                              ? "#adadad"
                              : scope.row.useStatus === 0
                              ? "#67C23A"
                              : "#Ec1c1c"
                        }
                      },
                      [_vm._v("● ")]
                    ),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.useStatus === 1
                            ? "已停用"
                            : scope.row.useStatus === 0
                            ? "启用中"
                            : "已删除"
                        )
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "handle-wrap" }, [
                      _c(
                        "p",
                        {
                          staticClass: "color-success",
                          class: { "dis-style": !_vm.haveAuth },
                          on: {
                            click: function($event) {
                              return _vm.addFlow({ row: scope.row })
                            }
                          }
                        },
                        [_vm._v("\n            编辑\n          ")]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "color-success",
                          class: { "dis-style": !_vm.haveAuth },
                          on: {
                            click: function($event) {
                              return _vm.switchStatus(scope.row)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                scope.row.useStatus === 1 ? "启用" : "停用"
                              ) +
                              "\n          "
                          )
                        ]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "color-success",
                          class: {
                            "dis-style":
                              !_vm.haveAuth ||
                              (_vm.haveAuth && scope.row.useStatus !== 1)
                          },
                          on: {
                            click: function($event) {
                              return _vm.del(scope.row)
                            }
                          }
                        },
                        [
                          scope.row.useStatus === 0
                            ? _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    content: "流程启用中，不可删除",
                                    placement: "bottom-end"
                                  }
                                },
                                [_c("span", [_vm._v("删除")])]
                              )
                            : _c("span", [_vm._v("删除")])
                        ],
                        1
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "pageation" },
        [
          _c(
            "el-col",
            {
              staticClass: "page-flex-end",
              staticStyle: { padding: "30px 0" },
              attrs: { span: 24 }
            },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.signFilter.itemPage,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.signFilter.pageSize,
                  layout: "sizes, prev, pager, next, total",
                  total: _vm.signFilter.pageTotal
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              }),
              _c("el-go", {
                staticStyle: { "margin-right": "5px" },
                attrs: {
                  "page-size": _vm.signFilter.pageSize,
                  total: _vm.signFilter.pageTotal
                },
                on: { "current-change": _vm.handleCurrentChange }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.pupTitle,
            visible: _vm.addFlowPupVisi,
            width: "65%",
            top: "13vh",
            "show-close": false,
            "lock-scroll": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.addFlowPupVisi = $event
            }
          }
        },
        [
          [
            _vm.isInDingTalk
              ? [
                  _vm.addFlowPupVisi
                    ? _c("ding-sign-approval", {
                        attrs: {
                          addFlowPupVisi: _vm.addFlowPupVisi,
                          currentFlowId: _vm.currentFlowId,
                          currentFlow: _vm.currentFlow
                        },
                        on: {
                          "update:addFlowPupVisi": function($event) {
                            _vm.addFlowPupVisi = $event
                          },
                          "update:add-flow-pup-visi": function($event) {
                            _vm.addFlowPupVisi = $event
                          },
                          filterSearch: _vm.filterSearch
                        }
                      })
                    : _vm._e()
                ]
              : _c("sign-approval", {
                  attrs: {
                    addFlowPupVisi: _vm.addFlowPupVisi,
                    currentFlowId: _vm.currentFlowId
                  },
                  on: {
                    "update:addFlowPupVisi": function($event) {
                      _vm.addFlowPupVisi = $event
                    },
                    "update:add-flow-pup-visi": function($event) {
                      _vm.addFlowPupVisi = $event
                    },
                    filterSearch: _vm.filterSearch
                  }
                })
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "h1",
      {
        staticClass: "com-title com-ht tree-title",
        staticStyle: { "padding-top": "0" }
      },
      [
        _c("i"),
        _c("span", { staticClass: "ms" }, [
          _vm._v("合同盖章时的审批流程，审批通过后合同才能成功盖章 ")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31f9e85d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f9e85d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/components/signSet.vue
// module id = okej
// module chunks = 7 30 56